var map = {
	"./Report.svg": 355,
	"./aisupport.svg": 358,
	"./avoidcroud.svg": 361,
	"./avoidface.svg": 300,
	"./avoidold.svg": 301,
	"./avoidpublic.svg": 362,
	"./check.svg": 814,
	"./control.svg": 356,
	"./cough.svg": 302,
	"./cross.svg": 815,
	"./distance.svg": 363,
	"./doIcon.svg": 364,
	"./dontDoIcon.svg": 365,
	"./dontcough.svg": 366,
	"./dontreuse.svg": 367,
	"./drinkwater.svg": 368,
	"./eco.svg": 816,
	"./expose.svg": 357,
	"./heart.svg": 354,
	"./jn.svg": 817,
	"./medical_support.svg": 359,
	"./nextArrow.png": 818,
	"./nextArrow.svg": 819,
	"./novisits.svg": 369,
	"./observador.svg": 820,
	"./prevArrow.svg": 821,
	"./previousArrow.png": 822,
	"./publico.svg": 823,
	"./safe.svg": 360,
	"./services.svg": 370,
	"./share.svg": 371,
	"./sleepAlone.svg": 372,
	"./telemovel.svg": 353,
	"./uporto.svg": 824,
	"./washHands.svg": 373,
	"./washing.svg": 374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 813;